import { useRef } from "react";

const WORDS = [
  "KISSIMMEE",
  "OCALA",
  "ORLANDO",
  "FLORIDA TRAILS",
  "TALON 1000",
  "RANCHER 420",
  "BEACH TOURS",
  "NIGHT RIDES",
];

/*
 * Auto-sliding editorial marquee. Continuous CSS keyframe scroll,
 * duplicated for a seamless loop.
 */
export default function EditorialMarquee() {
  const ref = useRef(null);
  const items = [...WORDS, ...WORDS, ...WORDS];

  return (
    <section
      ref={ref}
      className="relative bg-black py-4 md:py-6 border-y border-white/10 overflow-hidden"
      data-testid="editorial-marquee"
      aria-label="Serving Central Florida"
    >
      <div className="marquee-slow-track flex items-center gap-8 md:gap-12 whitespace-nowrap will-change-transform">
        {items.map((w, i) => (
          <span key={i} className="flex items-center gap-8 md:gap-12">
            <span
              className={`font-display uppercase leading-none text-2xl md:text-3xl tracking-wider ${
                i % 3 === 0
                  ? "text-[color:var(--primary)]"
                  : i % 3 === 1
                  ? "text-white"
                  : "text-white/40"
              }`}
            >
              {w}
            </span>
            <span className="text-[color:var(--primary)] text-lg">★</span>
          </span>
        ))}
      </div>
    </section>
  );
}
